import React, { memo } from 'react';

import ThemeButtons from '../../components/theme/ThemeButtons';
import LocalizationDropdown from '../../components/localization-dropdown/LocalizationDropdown';

const SecurityPageHeader = () => {
  return (
    <header className='security-page_header'>
      <div className='security-page_header_actions'>
        <LocalizationDropdown placement='bottom' />

        <div className='security-page_header_theme-switch'>
          <ThemeButtons />
        </div>
      </div>
    </header>
  );
};

export default memo(SecurityPageHeader);
